module.exports = __webpack_public_path__ + "static/media/dress.69dfa3f5.svg";